import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["messages", "isRequired"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import { FormField as InstUIFormField } from '@instructure/ui-form-field';
import { enhanceErrorMessages } from '../../util/enhanceErrorMessages';
import { enhanceLabel, hasErrorMessage } from '../../util/enhanceLabel';
import { bool } from 'prop-types';
var FormFieldComponent = forwardRef(function (_ref, ref) {
  var messages = _ref.messages,
    isRequired = _ref.isRequired,
    props = _objectWithoutProperties(_ref, _excluded);
  var messagesWithEnhancedErrors = enhanceErrorMessages(messages);
  var labelHasError = hasErrorMessage(messages);
  var enhancedLabel = enhanceLabel(props.label, isRequired, labelHasError);
  return /*#__PURE__*/React.createElement(InstUIFormField, Object.assign({}, props, {
    ref: ref,
    messages: messagesWithEnhancedErrors,
    label: enhancedLabel || ''
  }));
});

/**
 * This is a wrapper around the InstUI `FormField` component.
 *
 * Differences include:
 * - If the `label` prop is a string, it will be enhanced with an asterisk if `isRequired` is `true`
 * - If the `messages` prop contains an error message, it will include an icon
 */
export var FormField = Object.assign(FormFieldComponent, {
  // Note: `propTypes` are still required by functions such as `pickProps` and `omitProps`
  propTypes: _objectSpread(_objectSpread({}, InstUIFormField.propTypes), {}, {
    isRequired: bool
  })
});
export { FormPropTypes } from '@instructure/ui-form-field';
FormField.displayName = 'FormField';